<template>
  <b-modal
    id="otp-modal"
    ref="otpModal"
    :title="titleComputed"
    @close="cancel"
    @show="startInterval()"
    @hidden="cancel"
    centered
    :no-close-on-backdrop="noCloseOnBackdrop"
    >
    <div class="my-3" v-html="messageComputed"></div>
      <template v-if="isComment">
        <form
        id="form"
        novalidate
        class="position-relative"
        @submit.prevent
        >
          <LmTextArea
          v-if="type === 'textarea'"
          id="comment"
          v-model="form.comment"
          :label="$t(labelComment)"
          :v="isCommentValidationRequired ? customValidation : {value:false}"
          ref="lmTextArea"
          />
          <input
          v-if="type === 'token'"
          autocomplete="off"
          class="my-5 token"
          :v="isCommentValidationRequired ? customValidation : {value:false}"
          ref="lmTextArea"
          v-model.trim="form.comment"
          maxlength='6'
          />
        </form>
    </template>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="secondary"
          class="m-1 float-left"
          @click="resendOTP"
          :disabled="resendButtonDisabled"
        >
          {{resendButtonMessage}}
        </b-button>
        <b-button
          variant="primary"
          class="m-1 float-right"
          @click="ok"
        >
          Aceptar
        </b-button>
        <b-button
          variant="danger"
          class="m-1 float-right"
          @click="cancel"
        >
          Cancelar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import LmTextArea from '@/components/form/elements/LmTextArea.vue'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmTextArea
  },
  data () {
    return {
      messageData: '',
      titleData: '',
      isComment: false,
      isCommentValidationRequired: false,
      mustValidate: false,
      labelComment: '',
      initialForm: {},
      type: 'textarea',
      form: {
        comment: ''
      },
      seconds: 30,
      interval: null
    }
  },
  computed: {
    customValidation () {
      return {
        required: this.isCommentValidationRequired,
        $error: !this.form.comment && this.mustValidate
      }
    },
    messageComputed () {
      return this.messageData || this.message
    },
    titleComputed () {
      return this.titleData || this.title
    },
    resendButtonMessage () {
      if (this.seconds < 1) {
        return 'Reenviar'
      }
      return `Reenviar (${this.seconds})`
    },
    resendButtonDisabled () {
      if (this.seconds < 1) {
        return false
      } else {
        return true
      }
    }
  },
  props: {
    message: {
      type: String,
      default: function () {
        return this.$t('are_you_sure')
      }
    },
    title: {
      type: String,
      default: function () {
        return this.$t('are_you_sure')
      }
    },
    isTokenForExternal: {
      type: Boolean,
      default: false
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    lmShow () {
      this.$refs['otpModal'].show()
      return new Promise((resolve, reject) => {
        this.$on('ok', () => {
          resolve('ok')
        })
        this.$on('cancel', () => {
          // eslint-disable-next-line
          reject('cancel')
        })
      })
    },
    setMessageProps (message) {
      this.messageData = message
    },
    setTitleProps (title) {
      this.titleData = title
    },
    setIsCommentProps (isComment, isCommentValidationRequired, labelComment, type = 'textarea') {
      if (isComment) {
        this.type = type
        this.isComment = isComment
        this.labelComment = labelComment
        this.isCommentValidationRequired = isCommentValidationRequired
      }
    },
    ok (bvModalEvt) {
      this.mustValidate = this.isCommentValidationRequired
      if (this.isComment) {
        if (this.customValidation.$error) {
          bvModalEvt.preventDefault()
        } else {
          this.$emit('ok', this.form)
          this.mustValidate = false
        }
      } else {
        this.$emit('ok')
      }
      this.$refs['otpModal'].hide()
    },
    cancel () {
      if (this.isComment) {
        this.isComment = false
        this.isCommentValidationRequired = false
        this.form = JSON.parse(this.initialForm)
        this.$emit('cancel')
      } else {
        this.mustValidate = false
        this.$emit('cancel')
      }
      this.$refs['otpModal'].hide()
    },
    async resendOTP () {
      this.startInterval()
      try {
        if (this.isTokenForExternal) {
          await commonsApi.axiosPostWrapper('/documents/external', {
            request: 'generateotp',
            token: this.$route.params.token
          })
        } else {
          await commonsApi.axiosPostWrapper('/documents/generateotp', {
            id: this.$route.params.id
          })
        }
        return this.lmToastSuccessMessage('Código OTP reenviado correctamente.', 'Se generó un nuevo código')
      } catch (error) {
        console.log(error)
      }
    },
    startInterval () {
      this.clear()
      this.interval = setInterval(() => {
        this.seconds = this.seconds - 1
      }, 1000)
    },
    stopSeconds () {
      if (this.interval) clearInterval(this.interval)
      this.interval = null
    },
    clear () {
      this.stopSeconds()
      // Asigno 30 segundos antes de habilitar el botón de reenviar
      this.seconds = 30
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
  }
}
</script>

<style lang="sass" scoped>

$char-w: 1ch
$gap: .5*$char-w
$n-char: 6
$in-w: $n-char*($char-w + $gap)

input.token
  display: block
  margin: 2em auto
  border: none
  padding: 0
  width: $in-w
  background: repeating-linear-gradient(90deg, dimgrey 0, dimgrey $char-w, transparent 0, transparent $char-w + $gap) 0 100%/ #{$in-w - $gap} 2px no-repeat
  font: 5ch droid sans mono, consolas, monospace
  letter-spacing: $gap

  &:focus
    outline: none
</style>
